import { appHttpRequest } from '../../../utils/AppHttpRequest';
import { IPurchaseRoDetail } from './bmsBillPurchaseRoType';
class PurchaseRoService {
	async one(id: string) {
		const apiUrl = `/bcm/preturn/findById/${id}`;
		return await appHttpRequest.get<IPurchaseRoDetail>(apiUrl);
	}
}

export const purchaseRoService = new PurchaseRoService();
